import React, { useState, useEffect } from "react";
import { useRecoilValue } from 'recoil';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';

import Spinner from '../../../../Common/UI/Spinner/Spinner';
import { userListRefreshState } from '../../../../../core/store/UserStore';
import * as UserApi from '../../../../Common/Apis/UserApi';
import UserListItem from './UserListItem/UserListItem';
import PasswordReset from '../Dialog/PasswordReset';

const UserList = (props) => {
  const { addClaimTab } = props;

  const [isLoading, setisLoading] = useState(false);
  const [listData, setListData] = useState();
  const [pageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo] = useState(1);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [passwordResetItem, setPasswordResetItem] = useState();
  const userListRefresh = useRecoilValue(userListRefreshState);

  useEffect(() => {
    getList(1, pageSize, sortField, sortOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userListRefresh]);

  const pageSizeChanged = (i) => {
    getList(1, i, sortField, sortOrder);
  };

  const pageNoChanged = (i) => {
    getList(i, pageSize, sortField, sortOrder);
  };

  const sortFieldChanged = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);
    getList(pageNo, pageSize, e.sortField, e.sortOrder);
  };

  const submitForm = (e) => {
    e.preventDefault();
    getList(pageNo, pageSize);
  };

  const getList = async (_pageNo, _pageSize, _sortField, _sortOrder) => {
    setisLoading(true);

    try {
      const resData = await UserApi.getCustomerList(
        _sortField,
        _sortOrder === 1 ? UserApi.dataOrderAs.ASC : UserApi.dataOrderAs.DESC,
        _pageNo,
        _pageSize
      );
      setListData(resData);
    } catch (err) {
      console.log('err', err);
    }

    setisLoading(false);
  };

  return (
    <>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row ">
                    <div className="col-lg-2">
                      <div className="form-group">
                        <Button
                          type="submit"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                        >
                          Refresh
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <UserListItem
              items={listData}
              addClaimTab={addClaimTab}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
              sortFieldChanged={sortFieldChanged}
              sortField={sortField}
              sortOrder={sortOrder}
              passwordReset={e => setPasswordResetItem(e)}
            />}
          </div>
        </div>
      </div>
      {isLoading && <Spinner />}
      <PasswordReset
        isShow={passwordResetItem ? true : false}
        item={passwordResetItem}
        onClose={() => setPasswordResetItem()}
      />
    </>
  );
};

export default UserList;
